var MAIN_CONTENT_TYPE;
(function (MAIN_CONTENT_TYPE) {
  MAIN_CONTENT_TYPE["PDF"] = "PDF";
  MAIN_CONTENT_TYPE["VIDEO"] = "VIDEO";
  MAIN_CONTENT_TYPE["IMAGE"] = "IMAGE";
})(MAIN_CONTENT_TYPE || (MAIN_CONTENT_TYPE = {}));

export { MAIN_CONTENT_TYPE };
